const Modal = {
    parts: ['overlay'],

    baseStyle: {
        overlay: {
            backdropFilter: 'blur(10px)',
        },
    },

    defaultProps: {
        size: '3xl',
        isCentered: true,
    },
};

export default Modal;
